"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAncestorIds = exports.getDestinationTreeInfo = exports.destinationTreeItemFilterFn = void 0;
var FolderOutlineOpenIcon_1 = require("@tableau/icons/FolderOutlineOpenIcon");
var React = require("react");
var Localize_1 = require("../gen-src/Localize");
var DestinationItem_1 = require("./DestinationItem");
var NestedItemsFractalRowStore_1 = require("./NestedItemsFractalRowStore");
var NestedProjectExplorerCell_1 = require("./dataGridCells/NestedProjectExplorerCell");
var PersonalSpaceCellComponent_1 = require("./dataGridCells/PersonalSpaceCellComponent");
var destinationTreeItemFilterFn = function (item, searchText) {
    return item.destinationName.toLowerCase().includes(searchText.toLowerCase());
};
exports.destinationTreeItemFilterFn = destinationTreeItemFilterFn;
function getDestinationTreeInfo(destinations, topLevelDestinationStatus) {
    var destinationById = {};
    var destinationTreeItems = [];
    var personalSpaceItem;
    var addPermissonsRequiredItem = false;
    destinations.forEach(function (destination) {
        destinationById[destination.id] = destination;
        if (destination.itemType === DestinationItem_1.DestinationItemType.personalSpace) {
            personalSpaceItem = destination;
        }
    });
    // make sure personal space appears before everything else
    if (personalSpaceItem) {
        destinationTreeItems.push({
            content: React.createElement("span", { style: { alignItems: 'center', display: 'inline-flex', gap: 3 } },
                React.createElement("span", { "data-tb-test-id": 'name' }, Localize_1.Messages.PersonalSpaceName()),
                React.createElement("span", { "data-tb-test-id": 'tag', style: PersonalSpaceCellComponent_1.TagContainerStyle }, Localize_1.Messages.PrivateToMeTag())),
            destinationName: Localize_1.Messages.PersonalSpaceName(),
            disabled: personalSpaceItem.status !== 'valid',
            tooltip: Localize_1.Messages.PersonalSpaceName(),
            value: personalSpaceItem.id,
        });
    }
    destinations.forEach(function (destination) {
        if (destination.itemType === DestinationItem_1.DestinationItemType.personalSpace) {
            return;
        } // already handled above
        var parentValue = destination.parentId;
        if (!parentValue) {
            parentValue = NestedItemsFractalRowStore_1.NestedItemsFractalRowStore.SentinelRootProjectId;
        }
        else if (!destinationById[parentValue]) {
            addPermissonsRequiredItem = true;
            parentValue = NestedItemsFractalRowStore_1.NestedItemsFractalRowStore.SentinelPermissionsRequiredId;
        }
        destinationTreeItems.push({
            content: getContentForProject(destination.name),
            destinationName: destination.name,
            disabled: destination.status !== 'valid',
            parentValue: "".concat(parentValue),
            tooltip: (0, NestedProjectExplorerCell_1.messageForDestinationStatus)({ name: destination.name, status: destination.status }),
            value: destination.id,
        });
    });
    // special handling for the root project and the permissions required project
    destinationById[NestedItemsFractalRowStore_1.NestedItemsFractalRowStore.SentinelRootProjectId] = {
        id: NestedItemsFractalRowStore_1.NestedItemsFractalRowStore.SentinelRootProjectId,
        itemType: DestinationItem_1.DestinationItemType.projectsRoot,
        name: Localize_1.Messages.ProjectsHeader(),
        status: topLevelDestinationStatus,
    };
    destinationTreeItems.push({
        content: Localize_1.Messages.ProjectsHeader(),
        destinationName: Localize_1.Messages.ProjectsHeader(),
        disabled: topLevelDestinationStatus !== 'valid',
        tooltip: (0, NestedProjectExplorerCell_1.messageForDestinationStatus)({ name: Localize_1.Messages.ProjectsHeader(), status: topLevelDestinationStatus }),
        value: NestedItemsFractalRowStore_1.NestedItemsFractalRowStore.SentinelRootProjectId,
    });
    if (addPermissonsRequiredItem) {
        destinationById[NestedItemsFractalRowStore_1.NestedItemsFractalRowStore.SentinelPermissionsRequiredId] = {
            id: NestedItemsFractalRowStore_1.NestedItemsFractalRowStore.SentinelPermissionsRequiredId,
            itemType: DestinationItem_1.DestinationItemType.project,
            name: Localize_1.Messages.permissonsRequiredProjectName(),
            status: 'structurally_invalid',
        };
        destinationTreeItems.push({
            content: getContentForProject(Localize_1.Messages.permissonsRequiredProjectName()),
            destinationName: Localize_1.Messages.permissonsRequiredProjectName(),
            disabled: true,
            parentValue: NestedItemsFractalRowStore_1.NestedItemsFractalRowStore.SentinelRootProjectId,
            tooltip: (0, NestedProjectExplorerCell_1.messageForDestinationStatus)({ name: Localize_1.Messages.permissonsRequiredProjectName(), status: 'structurally_invalid' }),
            value: NestedItemsFractalRowStore_1.NestedItemsFractalRowStore.SentinelPermissionsRequiredId,
        });
    }
    return { destinationById: destinationById, destinationTreeItems: destinationTreeItems };
}
exports.getDestinationTreeInfo = getDestinationTreeInfo;
var getContentForProject = function (projectName) { return (React.createElement("span", { style: { display: 'inline-flex', gap: 5, lineHeight: '14px' } },
    React.createElement(FolderOutlineOpenIcon_1.FolderOutlineOpenIcon, { size: 14, style: { flexShrink: 0 } }),
    projectName)); };
function getAncestorIds(destinationById, selectedId) {
    var ancestorIds = new Set();
    if (selectedId) {
        var selectedItem = destinationById[selectedId];
        if (selectedItem && selectedItem.itemType === DestinationItem_1.DestinationItemType.project) {
            var parentId = selectedItem.parentId;
            while (parentId) {
                var parentItem = destinationById[parentId];
                if (parentItem) {
                    ancestorIds.add("".concat(parentId)); // make sure it's a string not a number
                    parentId = parentItem.parentId;
                }
                else {
                    ancestorIds.add(NestedItemsFractalRowStore_1.NestedItemsFractalRowStore.SentinelPermissionsRequiredId);
                    parentId = undefined;
                }
            }
            ancestorIds.add(NestedItemsFractalRowStore_1.NestedItemsFractalRowStore.SentinelRootProjectId);
        }
    }
    return ancestorIds;
}
exports.getAncestorIds = getAncestorIds;
//# sourceMappingURL=DestinationTreeItemHelper.js.map